
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/why-streamyard",
      function () {
        return require("private-next-pages/why-streamyard.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/why-streamyard"])
      });
    }
  